import React from 'react';
import Language from '../language/language';
import { withRouter } from 'react-router-dom';
import { Button, Select } from 'antd';
import Modal from '../modal/modal'
import { inject, observer } from 'mobx-react';
import moment from 'moment'
import './stylesheets/gameMeetingForm.scss'

const Option = Select.Option;

@inject('personGameStore', 'languageStore')
@withRouter
@observer
export default class GameMeetingForm extends React.Component {
  state = {
    registrationId: undefined,
    selectedDate: '',
    meetingOptions: [],
    selectedMeetingId: undefined,
    gameMeetingModal: false,
    messages: {
      dateError: '',
      timeError: ''
    }
  }

  componentDidMount () {
    let registrationId = undefined
    const { gameData } = this.props
    if (gameData && gameData.id) registrationId = gameData.id

    this.setState({
      registrationId
    })
  }

  handleDateChange = (date) => {
    this.setState({
      selectedDate: date,
      meetingOptions: this.props.meeting.meetings.filter(meeting => meeting.date === date),
      selectedMeetingId: undefined
    })
  }

  handleMeetingChange = (meetingId) => {
    if (meetingId) {
      this.setState({
        selectedMeetingId: meetingId
      })
    }
  }

  formatMeeting (option) {
    if (!option || !option.beginAt || !option.endAt) return '数据异常'
    return `${moment(option.beginAt).format('HH:mm')} ~ ${moment(option.endAt).format('HH:mm')}`
  }
  
  checkValues = () => {
    let dateError = ''
    let timeError = ''
    if (!this.state.selectedDate) {
      dateError = <Language resource="INTERVIEW_DATE_REQUIRE" />
    }
    if (!this.state.selectedMeetingId) {
      timeError = <Language resource="INTERVIEW_TIME_REQUIRE" />
    }
    this.setState({
      messages: {
        dateError,
        timeError
      }
    })
    if (!dateError && !timeError) {
      return true
    }
    else {
      return false
    }
  }

  showConfirmSubmit = () => {
    if (this.checkValues()) {
      this.setState({
        gameMeetingModal: true
      })
    }
  }

  closeConfirmSubmit = () => {
    this.setState({
      gameMeetingModal: false
    })
  }

  sumbitForm = () => {
    const form = {
      variables: {
        input: {
          attributes: {
            meetingId: this.state.selectedMeetingId,
            registrationId: this.state.registrationId
          }
        }
      }
    }
    this.props.personGameStore.setMeetingForm(form)
    this.props.personGameStore.submitMeetingForm().then(() => {
      this.setState({
        gameMeetingModal: false
      })
      this.props.personGameStore.getGameInfo(this.props.match.params.id)
    })
  }

  renderForm () {
    return (
      <div className="form-content">
        <div className="form-input">
          <div className="select">
            <div className="normal-label isRequired">
              <label><Language resource="CHOOSE_DATE" /></label>
            </div>
            <div className="normal-wrapper">
              <Select onChange={this.handleDateChange}>
                {this.props.meeting && this.props.meeting.dateOptions.map((option, index) => {
                  return <Option key={index} value={option}>{option}</Option>
                })}
              </Select>
            </div>
          </div>
          {this.state.messages.dateError
            ? 
              <div className="error">
                {this.state.messages.dateError}
              </div>
            : null
          }
        </div>
        <div className="form-input">
          <div className="select">
            <div className="normal-label isRequired">
            <label><Language resource="CHOOSE_TIME" /></label>
            </div>
            <div className="normal-wrapper">
              <Select value={this.state.selectedMeetingId} onChange={this.handleMeetingChange}>
                {this.state.meetingOptions.map((option) => {
                  return <Option disabled={option.full} key={option.id} value={option.id}>{this.formatMeeting(option)} {option.full ? <Language resource="MEETING_IS_FULL" /> : null}</Option>
                })}
              </Select>
            </div>
          </div>
          {this.state.messages.timeError
            ? 
              <div className="error">
                {this.state.messages.timeError}
              </div>
            : null
          }
        </div>
        <div className="form-input">
          <div className="submit">
            <Button onClick={this.showConfirmSubmit}>
              <Language resource="SUBMIT" />
            </Button>
          </div>
        </div>
      </div>
    )
  }

  render () {
    return (
      <div className="game-form-meeting">
        {this.props.meeting && this.props.meeting.hasSubmittedMeeting
          ? null
          : this.renderForm()
        }
        <Modal className="model-confirm-tip"  title={<Language resource="CONFIRM_SUBMIT_FORM" />}  state={this.state.gameMeetingModal}  close={this.closeConfirmSubmit} >
          <div className="confirm-tip">
            <Language resource="CONFIRM_SUBMIT_MEETING" />
          </div>
          <div className="operate">
            <Button onClick={this.sumbitForm}>
              <Language resource="CONFIRM" />
            </Button>
          </div>
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/formList/gameMeetingForm.js